import { render, staticRenderFns } from "./v-captcha.vue?vue&type=template&id=6286eaec&"
import script from "./v-captcha.js?vue&type=script&lang=js&"
export * from "./v-captcha.js?vue&type=script&lang=js&"
import style0 from "./v-captcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports